import { Collapsible } from '../interfaces';

export class InternalLocalFileReport implements Collapsible {
  internalLocalfileReportId: number;
  name: string;
  collapsed: boolean;
}
